import { AppUI } from '@seedlang/state';

const SeedlangOnly = ({ children }) => {
  if (AppUI.siteIsMemrev) {
    return null;
  }

  return children;
};

export default SeedlangOnly;